import { render } from "./document.vue?vue&type=template&id=49801c6e&scoped=true"
import script from "./document.vue?vue&type=script&lang=js"
export * from "./document.vue?vue&type=script&lang=js"

import "./document.vue?vue&type=style&index=0&id=49801c6e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49801c6e"]])

export default __exports__